'use client';
import { ModalID, useModal } from '@repo/ui/src/modules/UI';
import Box from '@mui/material/Box';
import PlaylistCard from '@repo/ui/src/components/PlaylistCard';

const YoutubeCard = (props) => {
  const {
    associatedPlaylist,
    youtubeId,
    youtubeLink,
    embedUrl,
    _playlistData,
    link,
    ariaLabel,
    darkMode,
  } = props;
  const { push } = useModal(ModalID.video);
  const builtYoutubeLink = youtubeLink || {
    youtubeId,
    link: embedUrl || null,
  };

  return (
    <div role="group" aria-label={ariaLabel} className="tw-h-full">
      <Box
        tabIndex={0}
        className={darkMode && 'dark-mode'}
        sx={{
          height: '100%',
          '&:focus': { outline: (theme) => `3px solid ${theme.palette.focus.main}` },
        }}
      >
        <PlaylistCard
          {...props}
          onClick={() =>
            push({
              link,
              youtubeLink: builtYoutubeLink,
              playlistItems: associatedPlaylist ? associatedPlaylist.body : _playlistData,
            })
          }
        />
      </Box>
    </div>
  );
};

export default YoutubeCard;
